/* eslint-disable max-len */
import { object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';

import LiveTVWidget from '../../../../collection-templates/videos-list-collection/live-tv-widget';
import TopNewsTitle from '../../../../molecules/titles/top-news';
import MarketImageHeadlineReaction from '../market-image-headline-reaction';
import MarketNewsReactionCard from '../market-news-reaction-card';

import './market-news-external-widget.m.css';

const MarketNewsExternalWidget = ({ collection, sectionTitle, widget }) => {
  const storyList = collection?.slice(0, 6);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const getSingleStoryMobileView = () => {
    if (storyList?.length) {
      return <MarketImageHeadlineReaction story={storyList[0]} />;
    }

    return null;
  };

  const title = sectionTitle;

  if (initialLoading) {
    return <div styleName="loading-container"></div>;
  }

  return (
    <div styleName="wrapper" className="row-section sidebar">
      <div>
        <div styleName="header">
          <TopNewsTitle title={title} />
        </div>
        {getSingleStoryMobileView()}

        <div styleName="story-list">
          {storyList?.map((item, index) => (
            <MarketNewsReactionCard key={index} newsItem={item} />
          ))}
        </div>
      </div>
      {!widget && (
        <div styleName="video-view">
          <LiveTVWidget sectionName="market-news-external-widget" />
        </div>
      )}
    </div>
  );
};

MarketNewsExternalWidget.propTypes = {
  collection: object,
  sectionTitle: string,
};
MarketNewsExternalWidget.nestedCollectionLimit = [6, 3];

export default MarketNewsExternalWidget;
